import { actionTypes } from './constants';
import { setCartItems } from './cartActions';

const headerActionCreators = {
    setUpdateUserState: updateUserState => {
        return { type: actionTypes.SET_UPDATE_USER_STATE, updateUserState };
    },
    setUserTypeTrade: isUserTypeTrade => {
        return { type: actionTypes.SET_USER_TYPE_TRADE, isUserTypeTrade };
    },
    setUserTypeVip: isUserTypeVip => {
        return { type: actionTypes.SET_USER_TYPE_VIP, isUserTypeVip };
    },
    setInitialTrackingFired: () => {
        return { type: actionTypes.INITIAL_TRACKING_FIRED };
    },
    setBannerMessages: bannerMessages => {
        return { type: actionTypes.SET_BANNER_MESSAGES, bannerMessages };
    },
};

const footerActionCreators = {
    setCurrency: currency => {
        return { type: actionTypes.SET_CURRENCY, currency };
    },
    setCurrencyUpdated: currencyUpdated => {
        return { type: actionTypes.SET_CURRENCY_UPDATED, currencyUpdated };
    },
    toggleMobileMenu: isMobileMenuOpen => {
        return { type: actionTypes.TOGGLE_MOBILE_MENU, isMobileMenuOpen };
    },
    setCartItems,
};

const actionCreators = {
    ...headerActionCreators,
    ...footerActionCreators,
};

export { actionCreators };
export default { actionCreators };
